// extracted by mini-css-extract-plugin
module.exports = {"full-page-load":"fullPageLoader-module__full-page-load___2Wyj8"};